"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _react = _interopRequireWildcard(require("react"));

var _NumberFormat = _interopRequireDefault(require("../../../NumberFormat"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    totalText: {
      display: 'inline-block',
      fontSize: 16,
      fontWeight: 'bold',
      color: palette.text.primary
    }
  };
});

var TotalCount = function TotalCount(_ref2) {
  var total = _ref2.total,
      boxProps = (0, _objectWithoutProperties2["default"])(_ref2, ["total"]);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    className: classes.totalText
  }, boxProps), "Showing (", /*#__PURE__*/_react["default"].createElement(_NumberFormat["default"], {
    format: "0,0"
  }, total), ")");
};

var _default = /*#__PURE__*/(0, _react.memo)(TotalCount);

exports["default"] = _default;